/**
 * Checks if a DOM element is visible. Takes into
 * consideration its parents and overflow.
 *
 * @param (el)      the DOM element to check if is visible
 *
 * These params are optional that are sent in recursively,
 * you typically won't use these:
 *
 * @param (t)       Top corner position number
 * @param (b)       Bottom corner position number
 * @param (w)       Element width number
 * @param (h)       Element height number
 */
export function isElemetVisible(el, t, b, w, h) {
    let p = el.parentNode;
    let VISIBLE_PADDING = 42;

    if (!elementInDocument(el)) {
        return false;
    }

    //-- Return true for document node
    if (9 === p.nodeType) {
        return true;
    }

    //-- Return false if our element is invisible
    if (
        '0' === getStyle(el, 'opacity') ||
        'none' === getStyle(el, 'display') ||
        'hidden' === getStyle(el, 'visibility')
    ) {
        return false;
    }

    if (
        'undefined' === typeof(t) ||
        'undefined' === typeof(b) ||
        'undefined' === typeof(w) ||
        'undefined' === typeof(h)
    ) {
        t = el.offsetTop;
        b = t + el.offsetHeight;
        h = el.offsetHeight;
    }
    //-- If we have a parent, let's continue:
    if (p) {
        //-- Check if the parent can hide its children.
        if (('hidden' === getStyle(p, 'overflow') || 'scroll' === getStyle(p, 'overflow'))) {
            //-- Only check if the offset is different for the parent
            if (
            //-- If the target element is under the parent elm
            t + VISIBLE_PADDING > p.offsetHeight + p.scrollTop ||
            //-- If the target element is above the parent elm
            t + h - VISIBLE_PADDING < p.scrollTop
            ) {
                //-- Our target element is out of bounds:
                return false;
            }
        }
        //-- Add the offset parent's left/top coords to our element's offset:
        if (el.offsetParent === p) {
            t += p.offsetTop;
        }
        //-- Let's recursively check upwards:
        return isElemetVisible(p, t, b, w, h);
    }
    return true;
}

//-- Cross browser method to get style properties:
function getStyle(el, property) {
    if (window.getComputedStyle) {
        return document.defaultView.getComputedStyle(el, null)[property];
    }
    if (el.currentStyle) {
        return el.currentStyle[property];
    }
}

function elementInDocument(element) {
    while (element = element.parentNode) {
        if (element == document) {
            return true;
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/common/lib/visibility.js